import { Grid, Box, Chip } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useEffect, useState, useCallback } from "react";
import { getNotificationCertificateFailures } from "../../services/NotificationCertificateService";
import DatagridCustom from "../General/DatagridCustom";
import { useToast } from "../../context/ToastContext";

export default function ManagerNotificationCertificateFailure() {
  const { showToast } = useToast();
  const [notificationCertificateFailures, setNotificationCertificateFailures] =
    useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const fetchNotificationCertificateFailures = useCallback(async () => {
    setLoading(true);

    try {
      const { page, pageSize } = paginationModel;
      const searchTerm = filterModel.quickFilterValues?.join(" ") || "";

      const res = await getNotificationCertificateFailures({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm,
      });

      setNotificationCertificateFailures(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (error) {
      console.error(
        "[ManagerNotificationCertificateFailure] Error al cargar datos:",
        error,
      );
      showToast(
        "No se pudieron cargar los archivos fallidos. Intente nuevamente.",
      "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModel, filterModel, showToast]);

  useEffect(() => {
    fetchNotificationCertificateFailures();
  }, [fetchNotificationCertificateFailures]);

  const handleFilterModelChange = useCallback(
    (newFilterModel) => {
      const currentSearchTerm = filterModel.quickFilterValues?.join(" ") || "";
      const newSearchTerm = newFilterModel.quickFilterValues?.join(" ") || "";

      setFilterModel(newFilterModel);

      if (currentSearchTerm !== newSearchTerm) {
        setPaginationModel((prev) =>
          prev.page !== 0 ? { ...prev, page: 0 } : prev,
        );
      }
    },
    [filterModel],
  );

  const columns = [
    {
      field: "updated_at",
      headerName: "Fecha de Actualización",
      flex: 1,
      valueGetter: (params) => {
        if (!params) return "";

        const date = new Date(params);

        if (isNaN(date.getTime())) {
          return "Fecha inválida";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
    {
      field: "original_name",
      headerName: "Nombre del Archivo",
      flex: 1,
    },
    {
      field: "stage_text",
      headerName: "Etapa",
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={params.value || params.row.stage || "-"}
          variant="outlined"
        />
      ),
    },
    {
      field: "reason",
      headerName: "Razón",
      flex: 1.2,
    },
    {
      field: "context",
      headerName: "Contexto",
      flex: 1.5,
      valueGetter: (params) => {
        if (!params) return "";

        try {
          return JSON.stringify(params, null, 2);
        } catch (e) {
          return "";
        }
      },
    },
  ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12 }}>

        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <DatagridCustom
            rows={notificationCertificateFailures}
            columns={columns}
            title="Listado de Cédulas Fallidas"
            description="Visualice los archivos de cédulas de notificación que no pudieron procesarse automáticamente."
            icon={<AssignmentIcon sx={{ fontSize: 32 }} />}
            paginationModel={paginationModel}
            onPaginationChange={setPaginationModel}
            total={total}
            loading={loading}
            filterModel={filterModel}
            onFilterChange={handleFilterModelChange}
            filterMode="server"
            isServerPagination={true}
          />
        </Box>
      </Grid>
    </Grid>
  );
}